import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

export default function PlanoPaginaMobileFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: `${theme.spacing[5]}px ${theme.spacing[4]}px`,
        gap: theme.spacing[5],
      }}
    >
      <Skeleton style={{ width: '45vw', height: 16 }} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing[4],
        }}
      >
        <Skeleton style={{ width: '35vw', height: 32 }} />
        <Skeleton style={{ height: 180 }} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[2],
          }}
        >
          <Skeleton style={{ width: '25vw', height: 25 }} />
          <Skeleton style={{ height: 60 }} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[2],
          }}
        >
          <Skeleton style={{ width: '20vw', height: 20 }} />
          <Skeleton style={{ height: 60 }} />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[2],
          }}
        >
          <Skeleton style={{ width: '45vw', height: 25 }} />
          <Skeleton style={{ height: 60 }} />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing[5],
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[2],
          }}
        >
          <Skeleton style={{ width: '45vw', height: 42 }} />
          <Skeleton style={{ height: 110 }} />
        </div>
      </div>
    </div>
  );
}
